module.exports = __webpack_public_path__ + "static/aarakokra-1-bc55b6a4b87982709b2306532fe063d1.jpg";